import {http} from '../axios'

export default {
  namespaced: true,
  state: {
    _loaded: false
  },
  mutations: {
    setAll(state, translates) {
      Object.assign(state, translates)
      state._loaded = true
    }
  },
  actions: {
    loadAll({commit, rootState}) {
      const prodLink = window.location.origin + `/all-translations_${rootState.currentLocale || 'ua'}.json`
      const isProduction = process.env.NODE_ENV === 'production' && window.location.hostname !== '95.216.212.103'

      const link = isProduction ? prodLink : prodLink //'/api/helper/all-translations'

      return http.get(link).then(({data}) => {
        commit('setAll', data.data)
      })
    }
  }
}
